import { reactive, computed } from 'vue'
import { defineStore } from 'pinia'

export default defineStore('contextStore', () => {
  const render = reactive({
    src: '',
  })
  const context: any = reactive({})

  const urlLang = computed<string | null>(() => {
    /* В случае, когда массив available_languages пустой, мы в urlLang возвращаем null, чтобы в reverseL10N убрать
     параметр language, так как в таком случае в url_patterns также не будет %(languages)s/ параметра */
    if (!context.available_languages?.length) {
      return null
    }

    // @ts-ignore
    const hasLangInAvailable = context.available_languages.some(({ iso }) => iso === context.current_language.iso)

    if (!hasLangInAvailable) {
      return null
    }

    return context.current_language.iso === context.default_language_iso ? '' : context.current_language.iso
  })

  return {
    render,
    context,
    urlLang,
  }
})
